import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "NoResultsRecommendations" }
const _hoisted_2 = {
  key: 0,
  class: "NoResultsText"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "SuggestionSection" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectedFilters = _resolveComponent("SelectedFilters")!
  const _component_DisciplineSuggestions = _resolveComponent("DisciplineSuggestions")!
  const _component_LocationSuggestions = _resolveComponent("LocationSuggestions")!
  const _component_Recommendations = _resolveComponent("Recommendations")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.resultsCount === 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, " No results for " + _toDisplayString(_ctx.pageTitle), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (_ctx.resultsCount <= _ctx.maxNumberOfResultsForSuggestions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "RemoveFiltersSuggestionsTitle" }, "Try removing some of your filters", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_SelectedFilters, {
              options: _ctx.selectedFiltersOptions,
              displaySection: _ctx.trackingDisplaySection
            }, null, 8 /* PROPS */, ["options", "displaySection"])
          ]),
          _createVNode(_component_DisciplineSuggestions),
          _createVNode(_component_LocationSuggestions)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.resultsCount === 0)
      ? (_openBlock(), _createBlock(_component_Recommendations, { key: 2 }))
      : _createCommentVNode("v-if", true)
  ]))
}